import { Image } from '../../../../Cloud.model';
import { Cards } from './ImageIconCard.model';

function normalize(value?: string): string {
    return (value || '').toLocaleLowerCase();
}

function isOperationalSystemType(image: Image): boolean {
    return normalize(image.type) === 'os';
}

function isImageUbuntu(image:Image):boolean{
    return (normalize(image.operationalSystem?.shortName) === 'ubuntu' && !(image.application))
}

function isImageWindows(image:Image):boolean{
    return (normalize(image.operationalSystem?.shortName) === 'windows')
}

function isImagecPanel(image:Image):boolean{
    return (normalize(image.application?.shortName) === 'cpanel')
}

function isImageRockylinux(image:Image):boolean{
    return (normalize(image.operationalSystem?.shortName) === 'rocky')
}

function isImageAlmalinux(image:Image):boolean{
    return (normalize(image.operationalSystem?.shortName) === 'alma' && (!image.application))
}

function isImageDebian(image:Image):boolean{
    const operationalSystemShortName = normalize(image.operationalSystem?.shortName);
    const operationalSystemName = normalize(image.operationalSystem?.name);

    return (
        isOperationalSystemType(image) &&
        !image.application &&
        (
            operationalSystemShortName === 'debian' ||
            operationalSystemName.startsWith('debian')
        )
    )
}

export function isShowImageByCard(image: Image, filter: Cards):boolean {

    switch (filter) {
        case 'ubuntu':
            return (isImageUbuntu(image))
        case 'windows':
            return (isImageWindows(image))
        case 'cpanel':
            return (isImagecPanel(image))
        case 'rocky':
            return (isImageRockylinux(image))
        case 'alma':
            return (isImageAlmalinux(image))
        case 'debian':
            return (isImageDebian(image))
        default:
            return !!(image.application);
    }
}

export function getCardByImage(image:Image):Cards{

    if(isImageUbuntu(image)){
        return Cards.ubuntu
    }
    if(isImageWindows(image)){
        return Cards.windows
    }
    if(isImagecPanel(image)){
        return Cards.cpanel
    }
    if(isImageRockylinux(image)){
        return Cards.rocky
    }
    if(isImageAlmalinux(image)){
        return Cards.alma
    }
    if(isImageDebian(image)){
        return Cards.debian
    }
    return Cards.app
}
